import { Divider, Tooltip, Zoom } from "@mui/material";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { DriverStatusColumnType } from "@/constants/driverStatuses";

function DriverStatusTooltip({ status, child }: { child: ReactElement; status: DriverStatusColumnType }) {
    const { t } = useTranslation();
    return (
        <Tooltip
            title={
                <div className="flex flex-col gap-2 p-1 !text-sm">
                    <div className="font-medium">
                        {t("driverStatuses." + status.status)}{" "}
                        <span className={status.payment ? "text-green-600" : "text-orange-600"}>
                            ({t(status.payment ? "paid" : "unpaid")})
                        </span>
                    </div>
                    <Divider className="!bg-gray-400 !w-3/4 !mr-auto" />
                    {t(`driverStatuses.${status.status}_DESC`)}
                </div>
            }
            arrow
            TransitionComponent={Zoom}
        >
            {child}
        </Tooltip>
    );
}

export default DriverStatusTooltip;
